export default "__VITE_ASSET__CXsHbbdE__"